var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDataflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_509_15919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 14.9993V14.8327C3.33333 13.4326 3.33333 12.7325 3.60582 12.1977C3.8455 11.7273 4.22795 11.3448 4.69836 11.1052C5.23314 10.8327 5.9332 10.8327 7.33333 10.8327H12.6667C14.0668 10.8327 14.7669 10.8327 15.3016 11.1052C15.772 11.3448 16.1545 11.7273 16.3942 12.1977C16.6667 12.7325 16.6667 13.4326 16.6667 14.8327V14.9993M3.33333 14.9993C2.41286 14.9993 1.66667 15.7455 1.66667 16.666C1.66667 17.5865 2.41286 18.3327 3.33333 18.3327C4.25381 18.3327 5 17.5865 5 16.666C5 15.7455 4.25381 14.9993 3.33333 14.9993ZM16.6667 14.9993C15.7462 14.9993 15 15.7455 15 16.666C15 17.5865 15.7462 18.3327 16.6667 18.3327C17.5871 18.3327 18.3333 17.5865 18.3333 16.666C18.3333 15.7455 17.5871 14.9993 16.6667 14.9993ZM10 14.9993C9.07952 14.9993 8.33333 15.7455 8.33333 16.666C8.33333 17.5865 9.07952 18.3327 10 18.3327C10.9205 18.3327 11.6667 17.5865 11.6667 16.666C11.6667 15.7455 10.9205 14.9993 10 14.9993ZM10 14.9993V6.66602M5 6.66602H15C15.7766 6.66602 16.1649 6.66602 16.4711 6.53915C16.8795 6.36999 17.204 6.04553 17.3731 5.63715C17.5 5.33087 17.5 4.94258 17.5 4.16602C17.5 3.38945 17.5 3.00116 17.3731 2.69488C17.204 2.2865 16.8795 1.96204 16.4711 1.79288C16.1649 1.66602 15.7766 1.66602 15 1.66602H5C4.22343 1.66602 3.83515 1.66602 3.52886 1.79288C3.12048 1.96204 2.79602 2.2865 2.62687 2.69488C2.5 3.00116 2.5 3.38945 2.5 4.16602C2.5 4.94258 2.5 5.33087 2.62687 5.63715C2.79602 6.04553 3.12048 6.36999 3.52886 6.53915C3.83515 6.66602 4.22343 6.66602 5 6.66602Z",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_509_15919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataflow);
export default __webpack_public_path__ + "static/media/dataflow.1f03a202387191aeeec2272435c6d84b.svg";
export { ForwardRef as ReactComponent };